<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/area_ac_count')">地区活跃度统计</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
              :inline="true"
          :model="filters"
        >
        <el-form-item
              label="查询时间"
            >
                <el-form-item prop="startTime">
                  <el-date-picker
                    type="date"
                    placeholder="选择开始日期"
                    v-model="filters.startTime"
                  ></el-date-picker>
                </el-form-item>
                <span style="display: inline-block;margin-right: 9px;">-</span>
                <el-form-item prop="endTime">
                  <el-date-picker
                    type="date"
                    placeholder="选择结束日期"
                    v-model="filters.endTime"
                  ></el-date-picker>
                </el-form-item>

            </el-form-item>
            <el-button
              style="margin-left:10px"
              @click="handleSearch"
              size="small"
            >搜索</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>

          <el-row>
            <el-col :span="5">
              <el-form-item
                label="所在省"
                prop="province"
              >
                <el-select
                  clearable
                  v-model="filters.province"
                  placeholder="请选择"
                  @change="changeCity"
                >
                  <el-option
                    v-for="option in provinceOptions"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">

              <el-form-item
                label="所在市"
                prop="city"
              >
                <el-select
                  clearable
                  v-model="filters.city"
                  placeholder="请选择"
                  @change="changeDistrict"
                >
                  <el-option
                    v-for="option in cityOptions"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">

              <el-form-item
                label="所在区"
                prop="district"
              >
                <el-select
                  clearable
                  v-model="filters.district"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in districtOption"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="代理类型">
                <el-select clearable v-model="filters.roleType" placeholder="请选择">
                  <el-option label="无" value="-1"></el-option>
                  <el-option label="康减系列vip会员" value="-0.5"></el-option>
                  <el-option label="康减系列高级会员" value="-0.4"></el-option>
                  <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                  <el-option label="康减系列市代" value="1.1"></el-option>
                  <el-option label="康减系列省代" value="2.1"></el-option>
                  <el-option label="康减系列CEO" value="3.1"></el-option>

                  <el-option label="VIP门店" value="0"></el-option>
                  <el-option label="联盟店" value="1"></el-option>
                  <el-option label="优秀联盟店" value="1.05"></el-option>
                  <el-option label="市代" value="2"></el-option>
                  <el-option label="省代" value="3"></el-option>
                  <el-option label="CEO" value="4"></el-option>
                  <el-option label="总经销商" value="5"></el-option>
                  <el-option label="销售公司" value="6"></el-option>

                  <el-option label="合伙人" value="2.2"></el-option>
                  <el-option label="董事" value="4.2"></el-option>
                <el-option label="经销商" value="4.8"></el-option>
                  <el-option label="区域总监" value="5.1"></el-option>
                  <el-option label="城市加盟商" value="5.2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="provinceName"
            label="省"
          >
          </el-table-column>

          <el-table-column
            prop="cityName"
            label="市"
            width="110"
          >
          </el-table-column>


          <el-table-column
            prop="name"
            label="区县"
          >
          </el-table-column>

          <el-table-column
            prop="inviteNum"
            label="人数"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                  @click="showDetailInfos(scope.row)"
                  type="text"
                  size="small"
                >查看明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="通过审核"
      :visible.sync="dialogEditVisible"
      width="20%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
      >
        <el-form-item label="管家类型">
          <el-select
            v-model="form.groupType"
            placeholder="请选择"
          >
            <el-option
              label="初级管家"
              value="1"
            ></el-option>
            <el-option
              label="中级管家"
              value="2"
            ></el-option>
            <el-option
              label="高级管家"
              value="3"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="throwGroupUp()"
            :loading="addLoading"
          >提交</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="驳回审核"
      :visible.sync="dialogEditVisible1"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="eForm"
        ref="eForm"
      >
        <el-form-item label='驳回理由'>
          <el-input
            v-model="eForm.reason"
            placeholder="请输入理由"
          >

          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="throwGroupUp()"
            :loading="addLoading"
          >提交</el-button>
          <el-button @click="dialogEditVisible1 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="店铺申请图片"
      :visible.sync="showPicLoading"
      width="40%"
    >
      <div class="shop-pic1">
        <img
          style="width:100%"
          v-for="url in detailPics"
          :key="url"
          :src="url"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="店铺申请图片"
      :visible.sync="showPicLoading1"
      width="40%"
    >
      <div class="shop-pic1">
        <img
          style="width:100%"
          v-for="url in detailPics1"
          :key="url"
          :src="url"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="明细"
      :visible.sync="subListVisible"
      width="80%"
    >
      <el-button
        style="margin-bottom:10px"
        @click="excelup"
        type="primary"
        size="small"
        >导出</el-button>

      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
            prop="username"
            label="姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="手机号"
            width="110"
          >
          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                :open-delay='delay'
                trigger="hover"
              >
                <img
                  style="max-height: 300px;max-width: 300px"
                  :src="scope.row.user_head"
                />
                <img
                  slot="reference"
                  :src="scope.row.user_head"
                  :alt="scope.row.user_head"
                  style="max-height: 50px;max-width: 130px"
                >
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            prop="send_integral"
            label="学习费"
          >
          </el-table-column>

          <el-table-column
            prop="deposit"
            label="保证金"
          >
          </el-table-column>

          <el-table-column
            prop="pay_money"
            label="购货金额"
          >
          </el-table-column>

          <el-table-column
            prop="total_money"
            label="实际下单金额"
          >
          </el-table-column>

          <el-table-column
            prop="province"
            label="省"
          >
          </el-table-column>

          <el-table-column
            prop="city"
            label="市"
          >
          </el-table-column>

          <el-table-column
            prop="district"
            label="区县"
          >
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="申请时间"
          >
          </el-table-column>
          <el-table-column
            :formatter="formatterRoleType"
            prop="role_type"
            label="申请角色"
          >
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="up_message"
            label="申请理由"
          >
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="loc_reason"
            label="店铺申请理由"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_num1"
          :page-count='total_page1'
          :page-size="page_size1"
          layout="total, prev, pager, next"
          :total="total_num1"
        >
        </el-pagination>
      </div>

    </el-dialog>

  </el-main>

</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "up_group_list",
  created() {},

  data() {
    return {
      subListVisible:false,
      delay: 0,
      searchAreaId:null,
      provinceOptions:[],
      filters: {
        startTime: null,
        endTime: null,
        roleType: null,
        title: null,
        upTel:null,
        provinceType:null,
        province: null,
        city: null,
        district: null,
        status: null
      },
      cityOptions: [],
      districtOption: [],
      isCollapse: true,
      activeName: "second",
      addLoading: false,
      page_num: 1,
      keywords: "",
      dialogEditVisible: false,
      dialogEditVisible1: false,
      value4: "",
      form: {
        id: null,
        groupType: null
      },
      eForm: {
        id: null,
        reason: null
      },
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      showPicLoading: false,
      showPicLoading1: false,
      detailPics: [],
      provinceList:null,
      detailPics1: [],
      tableHeight:null,
      page_num1: 1,
      total_num1: 0,
      tableDetailData:[],
      total_page1: 0,
      page_size1: 10,
      detailListLoading:false,
    };
  },
  mounted() {
    let that = this;
    this.tableHeight = document.documentElement.clientHeight - 330;
    var provinceList = localStorage.getItem("provinceList")
    if (provinceList && provinceList != null && provinceList != '')
    {
      this.provinceList = provinceList;
      this.provinceOptions = provinceList.split(',');
    } else {
API.get_province({ token: localStorage.getItem("api_token") })
      .then(
        function(result) {
          if (result.key == 1000) {
            that.provinceOptions = result.result.list;
          } else if (result.key == 1001) {
            bus.$emit("goto", "/login");
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    }
  },
  activated(){
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    showDetailInfos(row) {
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.searchAreaId = row;
      this.searchDetail();
    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        province: this.searchAreaId.provinceName,
        city: this.searchAreaId.cityName,
        district:this.searchAreaId.name,
        pageNum: that.page_num1,
        status:3,
        pageSize: that.page_size1
      };
      if (that.filters.startTime) {
        para.beginFinishTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        para.endFinishTime = that.filters.endTime.getTime();
      }
      if (that.filters.roleType) {
        para.roleType = that.filters.roleType;
      }
      that.detailListLoading = true;
      API.up_log_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.total_num1 = result.result.count;
              that.total_page1 = result.result.allPageNumber;
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    changeCity() {
      if (this.filters.province != null) {
        var that = this;
        API.get_city({
          token: localStorage.getItem("api_token"),
          province: this.filters.province
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.cityOptions = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    changeDistrict() {
      if (this.filters.city != null) {
        var that = this;
        API.get_district({
          token: localStorage.getItem("api_token"),
          city: this.filters.city
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.districtOption = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    goEditPage(row) {
      this.$router.push({ path: "/editUpLog", query: { good: row } });
    },
    showPicDialog(pics, type) {
      this.detailPics = null;
      if (type == 1)
      {
        this.detailPics = pics.loc_pics.split(",");
        if (pics.sign_pic != null)
        {
          this.detailPics.push(pics.sign_pic)
        }
        if (pics.check_sign != null)
        {
          this.detailPics.push(pics.check_sign)
        }
      } else {
        this.detailPics = [pics.up_reason_img];
      }
      this.showPicLoading = true;
    },
    showPicDialog1(pics) {
      this.detailPics1 = []
      this.detailPics1.push(pics.sign_pic)
      this.showPicLoading1 = true;
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    throwGroupUp1() {
      var that = this;
      if (!that.eForm.reason || that.eForm.reason == null) {
        that.$message.error({
          showClose: true,
          message: "请输入驳回理由",
          duration: 2000
        });
      } else {
        that.addLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          groupInId: that.eForm.id,
          status: 3,
          groupType: that.form.groupType,
          reason: that.eForm.reason
        };
        API.up_group_in(para)
          .then(
            function(result) {
              that.addLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "驳回成功",
                  duration: 1500
                });
                that.dialogEditVisible1 = false;
                that.search();
              }
            },
            function(err) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    throwGroupUp() {
      var that = this;
      if (!that.form.groupType || that.form.groupType == null) {
        that.$message.error({
          showClose: true,
          message: "请选择管家类型",
          duration: 2000
        });
      } else {
        that.addLoading = true;
        let para = {
          token: localStorage.getItem("api_token"),
          groupInId: that.form.id,
          status: 2,
          groupType: that.form.groupType
        };
        API.up_group_in(para)
          .then(
            function(result) {
              that.addLoading = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "通过成功",
                  duration: 1500
                });
                that.dialogEditVisible = false;
                that.search();
              }
            },
            function(err) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    excelup() {
      var that = this;
      var url =
        "/manager/user/pc/up_log_list_excel?userType=1&token=" +
        localStorage.getItem("api_token");

        url = url + "&status="+ 3

      if (that.searchAreaId.provinceName) {
        url = url + "&province=" +that.searchAreaId.provinceName;
      }
      if(that.searchAreaId.cityName){
        url = url+"&city="+ that.searchAreaId.cityName;
      }
      if(that.searchAreaId.name){
        url = url + "&district=" + that.searchAreaId.name;
      }
      if (that.filters.startTime) {
        url = url + "&beginFinishTime=" + that.filters.startTime.getTime();
      }else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endFinishTime=" + that.filters.endTime.getTime();
      }else {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.roleType) {
       url = url + "&roleType=" + that.filters.roleType;
      }
      top.location.href = url;
    },

    formatterStatus(row, column) {
      if (row.status == 0) {
        return "待付保证金";
      } else if (row.status == 1) {
        return "待填信息";
      } else if (row.status == 2) {
        if (row.loc_status == 2)
        {
          return "待购买商品";
        } else {
          return "完善信息待审核";
        }
      } else if (row.status == 3) {
        return "已完成";
      } else if (row.status == 4) {
        return "申请中";
      } else if (row.status == 5) {
        return "后台通过申请-待付学习费";
      } else if (row.status == 6) {
        return "已取消";
      } else if (row.status == 9) {
        return "待付学习费";
      } else if (row.status == 10) {
        return "待填信息";
      }
    },

    formatterRoleType(row, column) {
      if (row.role_type == 0) {
        if (row.su_type == 1)
        {
          return "束宣VIP门店";
        }
        else {
          return "煜美人VIP门店";
        }
      } else if (row.role_type == -0.5) {
        return "康减系列-vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列-高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列-荣誉会员";
      } else if (row.role_type == 1) {
        if (row.su_type == 1)
        {
          return "束宣联盟店";
        }
        else {
          if (row.province_type == 4)
          {
            return "康减康庭系列联盟店";
          } else if (row.province_type == 5) {
            return "康颜单项联盟店";
          } else {
            return "联盟店";
          }
        }
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        if (row.province_type == 1)
        {
          return "优秀省代";
        }
        else {
          return "战略省代";
        }
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      }  else if (row.role_type == 5) {
        return "总经销商";
      }  else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      } else if (row.role_type == 1.05) {
        if (row.su_type == 1)
        {
          return "束宣优秀门店";
        }
        else {
          return "煜美人优秀门店";
        }
      }
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/area_ac_info_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.province) {
        url = url + "&province=" + that.filters.province;
      }
      if (that.filters.city) {
        url = url + "&city=" + that.filters.city;
      }
      if (that.filters.district) {
        url = url + "&district=" + that.filters.district;
      }
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      // if (that.filters.province != null && that.filters.province != '') {
      //   url = url + "&province=" + that.filters.province;
      // } else if (that.provinceList != null && that.provinceList != '')
      // {
      //   url = url + "&province=" + that.provinceList;
      // }


      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }else {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }

      top.location.href = url;
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },
    upHouseLocStatus(row) {
      var that = this;
      this.$confirm(
        "请查看申请理由后，慎重选择操作方式，是否同意该代理的申请？",
        "审核操作",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "同意",
          cancelButtonText: "拒绝"
        }
      )
        .then(() => {
          //通过
          this.checkShopApply(row.id, 2);
        })
        .catch(action => {
          if (action === "cancel") {
            //拒绝
            this.checkShopApply(row.id, 3);
          }
        });
    },
    checkShopApply(id, status) {
      var that = this;
      that.loading = true;
      let para = {
        token: localStorage.getItem("api_token"),
        id: id,
        status: status
      };
      API.status_loc_up(para)
        .then(
          function(result) {
            that.loading = false;
            if (result && parseInt(result.key) === 1000) {
              that.$message.success({
                showClose: true,
                message: "操作成功",
                duration: 1500
              });
              that.search();
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定通过申请吗？";
        m2 = "通过成功后，该代理就可以支付保证金和购货进行升级";
        m3 = "通过成功";
        type = "warning";
      } else if (status == 2) {
        m1 = "确定删除该申请吗？";
        m2 = "删除成功后，本次申请就此结束。";
        m3 = "删除成功";
        type = "success";
      }
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status
          };
          API.status_province_up(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.province) {
        params.province = that.filters.province;
      }
      if (that.filters.city) {
        params.city = that.filters.city;
      }
      if (that.filters.district) {
        params.district = that.filters.district;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请选择开始时间",
            duration: 2000
          });
        return;
      }

      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请选择结束时间",
            duration: 2000
          });
        return;
      }

      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      // if (that.filters.province != null && that.filters.province != '')
      // {
      //   params.province = that.filters.province;
      // } else if (that.provinceList != null && that.provinceList != '')
      // {
      //   params.province = that.provinceList;
      // }
      that.loading = true;
      API.area_ac_info_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.list && result.result.list.length > 0) {
                // for (var i=0; i<result.list.length; i++)
                // {
                //   result.list[i].properties =
                // }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.shop-pic1 {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
  height: 80vh;
  overflow: hidden;
  overflow-y: auto;
}
.shop-pic1 img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 55105pxpx;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/area_ac_count.vue